module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlmax/Nagano_Chlmax_MRI_RCP26_Mid.png";